module.exports = __webpack_public_path__ + "img/car_0 - 副本.b9ebb4dd.png";